/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ctiproviderhuburl3Inputs */

const en_entity_ctiproviderhuburl3 = /** @type {(inputs: Entity_Ctiproviderhuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub URL`)
};

const de_entity_ctiproviderhuburl3 = /** @type {(inputs: Entity_Ctiproviderhuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub URL`)
};

/**
* | output |
* | --- |
* | "CTI Provider Hub URL" |
*
* @param {Entity_Ctiproviderhuburl3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ctiproviderhuburl3 = /** @type {((inputs?: Entity_Ctiproviderhuburl3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ctiproviderhuburl3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ctiproviderhuburl3(inputs)
	return de_entity_ctiproviderhuburl3(inputs)
});
export { entity_ctiproviderhuburl3 as "entity_ctiProviderHubUrl" }